import { render, staticRenderFns } from "./checkRecord.vue?vue&type=template&id=1d565ee6&scoped=true&"
import script from "./checkRecord.vue?vue&type=script&lang=js&"
export * from "./checkRecord.vue?vue&type=script&lang=js&"
import style0 from "./checkRecord.vue?vue&type=style&index=0&id=1d565ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d565ee6",
  null
  
)

export default component.exports